import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { CpAttachment, CpCorrespondenceItem } from '#models';

@Injectable({
  providedIn: 'root',
})
export class AttachmentsApiService {
  private _http = inject(HttpClient);
  private readonly _apiUrl = environment.apiUrl;

  // ─── CP case attachments ──────────────────────────────────────────────────

  getCpAttachments(caseId: number): Observable<CpAttachment[]> {
    return this._http.get<CpAttachment[]>(`${this._apiUrl}/cases/${caseId}/attachments`);
  }

  uploadCpAttachment(caseId: number, file: File, attachmentType: string): Observable<CpAttachment> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('attachmentType', attachmentType);
    return this._http.post<CpAttachment>(`${this._apiUrl}/cases/${caseId}/attachments`, formData);
  }

  deleteCpAttachment(caseId: number, attachmentId: number): Observable<void> {
    return this._http.delete<void>(`${this._apiUrl}/cases/${caseId}/attachments/${attachmentId}`);
  }

  downloadCpAttachment(caseId: number, attachmentId: number): Observable<{ downloadUrl: string }> {
    return this._http.get<{ downloadUrl: string }>(`${this._apiUrl}/cases/${caseId}/attachments/${attachmentId}/download`);
  }

  getCpCorrespondence(cpCaseId: number): Observable<CpCorrespondenceItem[]> {
    return this._http.get<CpCorrespondenceItem[]>(`${this._apiUrl}/cp-cases/${cpCaseId}/correspondence`);
  }

  getCpCorrespondenceDownloadUrl(cpCaseId: number, logId: number): Observable<{ downloadUrl: string }> {
    return this._http.get<{ downloadUrl: string }>(`${this._apiUrl}/cp-cases/${cpCaseId}/correspondence/${logId}/download`);
  }
}
